// Constants for report types and headers.
export interface ReportTypeOption {
  label: string;
  value: string;
}

const types: ReportTypeOption[] = [
  { label: 'Reporting', value: 'Reporting' },
  { label: 'User Activity', value: 'User Activity' },
  { label: 'User Status Report', value: 'User Status Report' },
  { label: 'Customer Feedback Report', value: 'Customer Feedback Report' },
  { label: 'Service Request Report', value: 'Service Request Report' },
  {
    label: 'Pre vs Post Occupancy Deficiency Report',
    value: 'OccupancyDeficiencyReport',
  },
];

const headers = [
  { label: 'Client', key: 'propertyName' },
  { label: 'Service Request ID', key: 'ticketNumber' },
  { label: 'Service Request Status', key: 'status' },
  { label: 'Service Request Age', key: 'serviceRequestAge' },
  { label: 'Service Request Created Date', key: 'createdDate' },
  { label: 'Service Request Closed Date', key: 'closedDate' },
  { label: 'Estimated Time', key: 'estimatedTime' },
  { label: 'Actual Time', key: 'actualTime' },
];

const userActivityHeaders = [
  { label: 'User/Account', key: 'userName' },
  { label: 'Date', key: 'date' },
  { label: 'Event', key: 'event' },
  { label: 'Time', key: 'time' },
  { label: 'Session Time', key: 'sessionTime' },
];

const userStatusReportsHeaders = [
  { label: 'Property', key: 'propertyName' },
  {
    label: localStorage.getItem('theme') === 'Shape' ? 'Unit' : 'Suite',
    key: 'suiteName',
  },
  { label: 'Name', key: 'name' },
  { label: 'Email', key: 'email' },
  { label: 'Phone', key: 'phone' },
  { label: 'Status', key: 'status' },
  { label: 'Designation', key: 'designation' },
];

const customerFeedBackHeaders = [
  { label: 'Service Request Id', key: 'ticketNumber' },
  { label: 'User/Account', key: 'userName' },
  { label: 'Email', key: 'email' },
  { label: 'Rating', key: 'rating' },
  { label: 'Feedback', key: 'feedback' },
  { label: 'Date ', key: 'createdOn' },
];

const occupancyDeficiencyHeaders = [
  { label: 'Property Name', key: 'propertyName' },
  { label: 'Unit', key: 'unitNumber' },
  { label: 'Building', key: 'building' },
  {
    label: 'Count of Internal Walkthrough Service Requests',
    key: 'internalWalkthroughServiceRequestsCount',
  },
  {
    label: 'Count of Homeowner Walkthrough Service Requests',
    key: 'homeOwnerWalkthroughServiceRequestsCount',
  },
  {
    label: 'Count of Warranty Service Requests',
    key: 'warrantyServiceRequestsCount',
  },
  {
    label: '% of Internal Walkthrough Service Requests',
    key: 'internalWalkthroughServiceRequestsPercentage',
  },
  {
    label: '% of Homeowner Walkthrough Service Requests',
    key: 'homeOwnerWalkthroughServiceRequestsPercentage',
  },
  {
    label: '% of Warranty Service Requests',
    key: 'warrantyServiceRequestPercentage',
  },
];

const propertyAggregateHeaders = [
  { label: 'Property Name', key: 'propertyName' },
  { label: 'Count of Internal Walkthrough Service Requests', key: 'internalWalkthroughServiceRequestsCount' },
  { label: 'Count of Homeowner Walkthrough Service Requests', key: 'homeOwnerWalkthroughServiceRequestsCount' },
  { label: 'Count of Warranty Service Requests', key: 'warrantyServiceRequestsCount' },
  { label: '% of Internal Walkthrough Service Requests', key: 'internalWalkthroughServiceRequestsPercentage' },
  { label: '% of Homeowner Walkthrough Service Requests', key: 'homeOwnerWalkthroughServiceRequestsPercentage' },
  { label: '% of Warranty Service Requests', key: 'warrantyServiceRequestPercentage' },
];


export {
  types,
  headers,
  userActivityHeaders,
  userStatusReportsHeaders,
  customerFeedBackHeaders,
  occupancyDeficiencyHeaders,
  propertyAggregateHeaders,
};
